import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { apiCall } from '../api/client';
import { toast } from 'sonner';

export default function HomeownerOnboarding() {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [zip, setZip] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    if (!name || !zip || zip.length !== 5) {
      toast.error('Please fill in all fields');
      return;
    }
    setLoading(true);
    try {
      const result = await apiCall('/profiles/homeowner', {
        method: 'POST',
        body: JSON.stringify({ display_name: name, zip_code: zip, terms_accepted: true }),
      });
      if (result.success) {
        toast.success('Welcome aboard!');
        navigate('/dashboard');
      } else {
        toast.error(result.error || 'Failed to create profile');
      }
    } catch { toast.error('Something went wrong'); }
    finally { setLoading(false); }
  };

  return (
    <div className="page" style={{ maxWidth: 480, margin: '0 auto', textAlign: 'center' }}>
      <img src="/assets/logo-icon.svg" alt="" style={{ width: 64, height: 64, marginBottom: 16 }} />
      <h1 style={{ fontSize: '1.6rem', fontWeight: 700, marginBottom: 8 }}>Welcome, Homeowner!</h1>
      <p style={{ opacity: 0.7, marginBottom: 32 }}>Just a couple things to get you started.</p>
      <div style={{ textAlign: 'left' }}>
        <label style={{ fontWeight: 600, display: 'block', marginBottom: 4 }}>Your Name</label>
        <input type="text" value={name} onChange={e => setName(e.target.value)} placeholder="e.g. Alex" style={{ width: '100%', padding: '12px 16px', borderRadius: 'var(--radius-md)', border: '2px solid var(--color-tan)', fontFamily: 'var(--font-family)', fontSize: '1rem', marginBottom: 16, background: 'var(--color-cream)' }} />
        <label style={{ fontWeight: 600, display: 'block', marginBottom: 4 }}>Zip Code</label>
        <input type="text" value={zip} onChange={e => setZip(e.target.value.replace(/\D/g, '').slice(0, 5))} placeholder="22030" maxLength={5} style={{ width: '100%', padding: '12px 16px', borderRadius: 'var(--radius-md)', border: '2px solid var(--color-tan)', fontFamily: 'var(--font-family)', fontSize: '1rem', marginBottom: 24, background: 'var(--color-cream)' }} />
      </div>
      <div className="disclaimer" style={{ marginBottom: 16 }}>By continuing, you accept the <a href="/consumer-agreement">Consumer Agreement</a>.</div>
      <button className="btn-primary" onClick={handleSubmit} disabled={loading} style={{ width: '100%' }}>
        {loading ? 'Setting up...' : 'Get Started →'}
      </button>
    </div>
  );
}
